module.exports = __webpack_public_path__ + "assets/media/email.990aafff.mp3";